
{
  "familyId": "GET-VERH-SCHAAL-KAART",
  "questions": [
    {
      "id": "GET-VERH-SCHAAL-KAART-001",
      "familyId": "GET-VERH-SCHAAL-KAART",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_schaal_kaart",
      "questionType": "multiple_choice",
      "question": "Op een kaart met schaal 1 : 50.000 is de afstand tussen twee dorpen 4 cm. Wat is de werkelijke afstand?",
      "options": [
        "2 km",
        "200 m",
        "20 km",
        "2000 m"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schaal_kaart_naar_werkelijk",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig de kaartafstand met de schaalfactor. Stap 1: 4 cm × 50.000 = 200.000 cm. Stap 2: 200.000 cm = 2.000 m = 2 km.",
        "distractorExplanations": {
          "0": "Goed! 4 × 50.000 = 200.000 cm = 2 km.",
          "1": "Veelgemaakte fout: niet omrekenen naar km. 200.000 cm = 2.000 m = 2 km, niet 200 m.",
          "2": "Veelgemaakte fout: een factor 10 te veel. 4 × 50.000 = 200.000 cm = 2 km, niet 20 km.",
          "3": "Dit is hetzelfde als 2 km! 2.000 m = 2 km. Maar de gebruikelijke eenheid voor deze afstand is km."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-KAART-002",
      "familyId": "GET-VERH-SCHAAL-KAART",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_schaal_kaart",
      "questionType": "multiple_choice",
      "question": "De werkelijke afstand is 10 km. De schaal is 1 : 200.000. Hoe lang is de afstand op de kaart?",
      "options": [
        "5 cm",
        "50 cm",
        "0,5 cm",
        "500 cm"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schaal_werkelijk_naar_kaart",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Strategie: deel de werkelijke afstand door de schaalfactor. Stap 1: 10 km = 1.000.000 cm. Stap 2: 1.000.000 ÷ 200.000 = 5 cm.",
        "distractorExplanations": {
          "0": "Goed! 10 km = 1.000.000 cm. 1.000.000 ÷ 200.000 = 5 cm op de kaart.",
          "1": "Veelgemaakte fout: km niet omrekenen naar cm. 10 km = 1.000.000 cm, niet 10.000 cm.",
          "2": "Veelgemaakte fout: een factor 10 te weinig. Controleer: 10 km = 1.000.000 cm ÷ 200.000 = 5 cm.",
          "3": "Veelgemaakte fout: vermenigvuldigen in plaats van delen. Bij kaart → werkelijk vermenigvuldig je. Bij werkelijk → kaart deel je."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-KAART-003",
      "familyId": "GET-VERH-SCHAAL-KAART",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_schaal_kaart",
      "questionType": "multiple_choice",
      "question": "Op een kaart is 1 cm gelijk aan 5 km in werkelijkheid. Wat is de schaal?",
      "options": [
        "1 : 500.000",
        "1 : 5.000",
        "1 : 50.000",
        "1 : 5.000.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schaal_bepalen",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: zet beide afstanden in dezelfde eenheid. Stap 1: 5 km = 500.000 cm. Stap 2: 1 cm op kaart = 500.000 cm in werkelijkheid. Stap 3: Schaal = 1 : 500.000.",
        "distractorExplanations": {
          "0": "Goed! 5 km = 500.000 cm, dus schaal = 1 : 500.000.",
          "1": "Veelgemaakte fout: km naar m omrekenen (5 km = 5.000 m), maar schaal is in cm. 5 km = 500.000 cm.",
          "2": "Veelgemaakte fout: een factor 10 te weinig. 5 km = 500.000 cm, niet 50.000 cm.",
          "3": "Veelgemaakte fout: een factor 10 te veel. 5 km = 500.000 cm, niet 5.000.000 cm."
        }
      }
    },
    {
      "id": "GET-VERH-SCHAAL-KAART-004",
      "familyId": "GET-VERH-SCHAAL-KAART",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_schaal_kaart",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond (schaal 1 : 100) is een kamer 8 cm lang en 5 cm breed. Wat is de werkelijke lengte van de kamer?",
      "options": [
        "8 meter",
        "80 meter",
        "0,8 meter",
        "800 meter"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schaal_plattegrond",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig met de schaalfactor. Stap 1: 8 cm × 100 = 800 cm. Stap 2: 800 cm = 8 meter.",
        "distractorExplanations": {
          "0": "Goed! 8 cm × 100 = 800 cm = 8 meter.",
          "1": "Veelgemaakte fout: niet omrekenen naar meter. 800 cm = 8 m, niet 80 m.",
          "2": "Veelgemaakte fout: delen in plaats van vermenigvuldigen. Van kaart naar werkelijk: vermenigvuldig.",
          "3": "Veelgemaakte fout: een factor 100 te veel. 8 cm × 100 = 800 cm = 8 m, niet 800 m."
        }
      }
    }
  ]
}
